import { AuditEventCategory, AuditItem, AuditItemResponseDTO } from "@dto/auditResponse.dto";
import { DateUtil } from "@dto/util/DateUtil";
import { TabsProps } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import { useEffect, useState } from "react";
import XmTabsSticky from "src/component/stickyTab/XmTabsSticky";
import useDebounce from "src/hook/useDebounce";
import useGetApiData from "src/hook/useGetApiData";
import { useHashTab } from "src/routing/tabHash";
import AuditDatePicker from "./AuditLogDatePicker";
import AuditTable, { TableData } from "./AuditLogTable";

const toSeconds = (time: Date) => (Math.round(time.getTime() / 1000));
const oneDayRange = (): { start: Date, end: Date; } => {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - 1);
  return { start, end };
};

const TAB_KEYS = Object.values(AuditEventCategory);

const AuditLog = () => {
  const { activeKey: tab, onChange: setTab } = useHashTab(TAB_KEYS, AuditEventCategory.SYSTEM);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [apiParams, setApiParams] = useState<{ start: Date, end: Date; }>(oneDayRange());
  const debouncedApiParams = useDebounce(apiParams);
  const [isTimeSet, setIsTimeSet] = useState(true);
  const [data, , loading] = useGetApiData<AuditItem[], AuditItemResponseDTO>(
    `/api/audit/v1?start=${toSeconds(apiParams.start)}&end=${toSeconds(apiParams.end)}`,
    "Get Logs failed",
    [debouncedApiParams],
    []
  );

  useEffect(() => {
    const tableDataFiltered = data
      .filter(log => log.category === tab)
      .map((event, value) => ({
        ...event,
        rowKey: value,
        inSeconds: toSeconds(new Date(event.time)),
        time: DateUtil.getDateISO(new Date(event.time)),
      }));

    setTableData(tableDataFiltered);
  }, [data, tab]);


  const handleRangeChange: RangePickerProps['onChange'] = (values) => {
    if (!values) {
      setIsTimeSet(false);
      return;
    }

    setIsTimeSet(true);
    setApiParams({ start: values[0].toDate(), end: values[1].toDate() });
  };

  const auditContent = (
    <div className="audit-container">
      <AuditTable data={tableData} allData={tableData} loading={loading} />
      <AuditDatePicker
        isTimeSet={isTimeSet}
        startDate={apiParams.start}
        endDate={apiParams.end}
        onChange={handleRangeChange}
      />
    </div>
  );

  const items: TabsProps['items'] = [
    { key: AuditEventCategory.SYSTEM, label: "System Configuration", children: auditContent },
    { key: AuditEventCategory.USER, label: "User Settings", children: auditContent },
  ];

  return (
    <XmTabsSticky
      onChange={setTab}
      activeKey={tab}
      items={items}
    />
  );
};

export default AuditLog;